import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/ecommerce.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const EcommercePlatforms = () => {
  const heroData = {
    title: "High-Performance Ecommerce Platform Development",
    description: "Transform your retail business with powerful ecommerce platforms that drive sales and deliver exceptional shopping experiences. We build scalable online stores that convert visitors into loyal customers.",
    image: img13,
    imageAlt: "Ecommerce Platforms",
    features: [
      "Conversion-optimized design",
      "Secure payment processing",
      "Inventory management",
      "Mobile-first approach",
      "Marketing automation",
      "Analytics & insights",
    ],
    pillars: [
      "User experience that delights and converts shoppers",
      "Robust infrastructure that ensures reliability and security",
      "Powerful features that streamline operations and scale with growth",
    ],
  };

  const journeySteps = [
    {
      title: "Business Analysis",
      description: "We analyze your products, target market, competition, and business model to design the perfect ecommerce strategy and platform architecture.",
      details: ["Product analysis", "Market research", "Competitor review", "Business model", "Payment strategy", "Shipping logistics"],
    },
    {
      title: "Platform Design",
      description: "Our team creates conversion-optimized user flows and engaging shopping experiences that turn browsers into buyers.",
      details: ["UX design", "Product pages", "Checkout flow", "Mobile optimization", "Brand integration", "A/B testing plan"],
    },
    {
      title: "Development & Integration",
      description: "We build robust ecommerce platforms with seamless payment gateways, shipping integrations, and inventory management systems.",
      details: ["Platform development", "Payment gateways", "Shipping APIs", "Inventory system", "ERP integration", "Security implementation"],
    },
    {
      title: "Launch & Growth",
      description: "From launch to optimization, we help you scale your online store with analytics, marketing tools, and continuous improvements.",
      details: ["Store launch", "Analytics setup", "Marketing integration", "Performance monitoring", "Conversion optimization", "Growth strategies"],
    },
  ];

  const capabilities = [
    {
      title: "B2C Ecommerce",
      content:
        "Feature-rich online stores for direct-to-consumer sales with personalized shopping experiences and conversion optimization.",
    },
    {
      title: "B2B Platforms",
      content:
        "Wholesale and B2B ecommerce solutions with bulk ordering, custom pricing, quote management, and account-based features.",
    },
    {
      title: "Marketplace Development",
      content:
        "Multi-vendor marketplaces with vendor management, commission systems, and comprehensive admin controls.",
    },
    {
      title: "Headless Commerce",
      content:
        "Modern headless ecommerce architecture that delivers exceptional performance and omnichannel shopping experiences.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "+120%", label: "Average sales increase" },
      { value: "4.2%", label: "Average conversion rate" },
      { value: "60%", label: "Mobile revenue share" },
    ],
    description: "We deliver ecommerce platforms that drive significant revenue growth, improve conversion rates, and create loyal customer bases.",
  };

  const outcomesData = {
    description: "We create ecommerce platforms that combine beautiful design with powerful functionality, delivering exceptional shopping experiences that drive sales and customer loyalty.",
    outcomes: [
      "Mobile-responsive and app-like user experience",
      "Secure payment gateway integrations",
      "Advanced product catalog and search",
      "Shopping cart and wishlist functionality",
      "Order management and tracking systems",
      "Marketing automation and analytics",
    ],
  };

  const whyChooseUs = [
    {
      title: "Conversion Focused",
      content:
        "Every element is designed to maximize conversions, from intuitive product pages to streamlined checkout processes.",
    },
    {
      title: "Scalable Technology",
      content:
        "Built to handle growth from startup to enterprise, supporting thousands of products and high-traffic volumes.",
    },
    {
      title: "Seamless Integrations",
      content:
        "Connect with leading payment processors, shipping carriers, ERPs, and marketing tools for end-to-end automation.",
    },
    {
      title: "Mobile-First Design",
      content:
        "Optimized mobile shopping experiences that drive sales across all devices and screen sizes.",
    },
  ];

  const faqs = [
    {
      q: "Which ecommerce platform should I choose?",
      a: "It depends on your business size and needs. Shopify works great for small to medium businesses, WooCommerce for WordPress users, and custom solutions for unique requirements. We'll recommend the best fit for your goals.",
    },
    {
      q: "How long does it take to build an ecommerce store?",
      a: "A basic store can be launched in 6-8 weeks, while complex custom platforms may take 3-6 months. Timeline depends on features, integrations, number of products, and customization requirements.",
    },
    {
      q: "What payment gateways do you integrate?",
      a: "We integrate all major payment gateways including Stripe, PayPal, Square, Authorize.net, and regional processors. We also support multiple payment methods like credit cards, digital wallets, and buy-now-pay-later options.",
    },
    {
      q: "Can you help with ongoing store management and optimization?",
      a: "Yes! We offer ongoing support including performance optimization, conversion rate improvements, security updates, feature additions, and marketing integration to help your store grow continuously.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Ecommerce Platform Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Ecommerce Platform Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default EcommercePlatforms;
